import { render, staticRenderFns } from "./cameras_config_list.vue?vue&type=template&id=9b2237c0"
import script from "./cameras_config_list.vue?vue&type=script&lang=js"
export * from "./cameras_config_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports